import api from './authService';

export const whatsappSettingsService = {
  // Get WhatsApp settings for organization
  getWhatsappSettings: async (organizationId) => {
    try {
      const response = await api.get(`/whatsapp-settings/organization/${organizationId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching WhatsApp settings:', error);
      throw error;
    }
  },

  // Save/Update WhatsApp settings
  saveWhatsappSettings: async (organizationId, settingsData) => {
    try {
      const response = await api.post(`/whatsapp-settings/organization/${organizationId}`, settingsData);
      return response.data;
    } catch (error) {
      console.error('Error saving WhatsApp settings:', error);
      throw error;
    }
  },

  // Delete WhatsApp settings
  deleteWhatsappSettings: async (organizationId) => {
    try {
      const response = await api.delete(`/whatsapp-settings/organization/${organizationId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting WhatsApp settings:', error);
      throw error;
    }
  }
};
